// extracted by mini-css-extract-plugin
export default {"Italic":"Mdnbn_07"};